/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import { ReactSVG } from 'react-svg';
import React, { Children, isValidElement, useMemo } from 'react';
import { HEADER_HEIGHT } from '@/constants';
import { composeClassName } from '@/utils/util_helpers';
import { HeaderLinkProps } from './components/header-link/types';
import { HeaderLink } from './components/header-link';
import { MobileSideMenu } from './components/mobile-side-menu';
import { HeaderProps, Slots } from './types';
import { MobileSideMenuPropsAndSubComponents } from './components/mobile-side-menu/types';

const Leading: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div
      className="flex h-full items-center gap-3 lg:gap-2"
    >
      <a href="/" aria-label="Coloc Housing – Home">
        <ReactSVG
          src={require(`@assets/icons/other/coloc-icon.svg`)}
          className="inline-block align-baseline w-[67px] h-[34px] sm:w-[87px] sm:h-[44px] md:w-[99px] md:h-[50px]"
          beforeInjection={(svg) => {
            svg.setAttribute('width', '100%');
            svg.setAttribute('height', '100%');
            svg.setAttribute('aria-hidden', 'true');
          }}
        />
      </a>
      {children}
    </div>
  );
};

const Trailing: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  return (
    <div className={composeClassName('flex h-full items-center', className)}>
      {children}
    </div>
  );
};

const Header: React.FC<HeaderProps> & {
  HeaderLink: React.FC<HeaderLinkProps>;
  Leading: React.FC<{ children: React.ReactNode }>;
  Trailing: React.FC<{ children: React.ReactNode; className?: string }>;
  MobileSideMenu: MobileSideMenuPropsAndSubComponents;
} = ({ children }) => {
  const filledSlots = useMemo(() => {
    const slots: Slots = {
      leading: null,
      trailing: null,
    };

    Children.toArray(children).forEach((child) => {
      if (!isValidElement(child)) {
        return;
      }

      switch (child.type) {
        case Leading:
          slots.leading = child;
          break;
        case Trailing:
          slots.trailing = child;
          break;
        default:
      }
    });

    return slots;
  }, [children]);

  // Base classes for the header, including transitions but excluding the 'top' offset
  const baseHeaderClasses =
    'max-w-[130rem] rounded-[50px] sm:w-[80%] w-[calc(100%-theme(space.7))] m-auto inset-x-0 fixed z-40 flex items-center justify-between shadow-[-16px_5px_30px_0px_rgba(18,2,47,0.04)] transition-all duration-300 ease-in-out';
  return (
    <header
      className={composeClassName(
        baseHeaderClasses,
        HEADER_HEIGHT,
      )}
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(12px)',
        top: '2%',
      }}
    >
      <div 
        className="m-auto flex w-[calc(100%-theme(space.7))] max-w-[130rem] items-center justify-between lg:px-[3rem] md:px-[2rem] sm:px-[1rem]"
      >
        {filledSlots.leading}
        {filledSlots.trailing}
      </div>
    </header>
  );
};

Header.HeaderLink = HeaderLink;
Header.Leading = Leading;
Header.Trailing = Trailing;
Header.MobileSideMenu = MobileSideMenu;

export { Header };
